import { Component, Injector, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { DecisionModelWorkflowOrchestrator } from './orchestrator';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-decision-model',
  template: '<app-loader [isLoading]="true"></app-loader>',
})
export class DecisionModelComponent implements OnInit, OnDestroy {
  private readonly orchestrator: DecisionModelWorkflowOrchestrator;
  private readonly unSubscribe$: Subject<void>;
  public showLoader = true;

  constructor(private readonly injector: Injector) {
    this.orchestrator = this.injector.get(DecisionModelWorkflowOrchestrator);

    this.unSubscribe$ = new Subject<void>();
  }

  public ngOnInit(): void {
    this.orchestrator.run(this.injector).pipe(takeUntil(this.unSubscribe$)).subscribe();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
